import { render } from "./EditInternshipModal.vue?vue&type=template&id=3f551878&ts=true"
import script from "./EditInternshipModal.vue?vue&type=script&lang=ts"
export * from "./EditInternshipModal.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__